export default "__VITE_ASSET__DIKKnj7X__"